import axios from './intercept.js';
// 设置baseUrl
let baseUrl = 'https://xiehuiapi.zjbinfo.com';
const env = process.env.NODE_ENV;
if (env === 'development') {
    baseUrl = '/other';
}

const getBannerList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetBannerList', {params});
const getYaowenList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetYaowenList', {params});
const getDangjianList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetDangjianList', {params});
const getProjectList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetProjectList', {params});
const getProjectDetail = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetProjectDetail', {params});
const getFoodShop = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetFoodShop', {params});
const getFoodShopDetail = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetFoodShopDetail', {params});
const getZhujingbanList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetZhujingbanList', {params});
const getPingpaiActivityList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetPingpaiActivityList', {params});
const getPlolicyDetail = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetPlolicyDetail', {params});
const getCityShowList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetCityShowList', {params});
const getJingcaiList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetJingcaiList', {params});
const getJingcaiDetail = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetJingcaiDetail', {params});
const getProjectDown = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetProjectDown', {params});
const getXiehuiModel = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetXiehuiModel', {params});
const getXiehuiExport = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetXiehuiExport', {params});
const getCompanyList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetCompanyList', {params});
const getCompanyDetail = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetCompanyDetail', {params});
const getYaowen = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetYaowen', {params});
const getGongxiangZhujingban = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetGongxiangZhujingban', {params});
const getFocusNews = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetFocusNews');
const getZhujingbanWork = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetZhujingbanWork', {params});
const getGongxiang = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetGongxiang', {params});
const getCompanynWork = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetCompanynWork', {params});
const getFoodArea = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetFoodArea');
const getFoodCookingStyle = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetFoodCookingStyle');   
const getFoodList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetFoodList', {params});   
const getActivityList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetActivityList', {params});
const getExpertList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetExpertList', {params});        
const addContact = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddContact', params);
const login = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/Login', params);     
const addBaoming = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddBaoming', params);     

const getMedicalKnowledge = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetMedicalKnowledge', {params});
const getKnowledgeDetail = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetKnowledgeDetail', {params});
const getMedical = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetMedical', {params});
const getProjectShow = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetProjectShow', {params});
const addMatericalService = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddMatericalService', params); 
const getZhengceList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetZhengceList', {params});  
const getSearchKey = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetSearchKey', {params});
const getXiehuiVIP = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetXiehuiVIP', {params});
const getJingcaiGroupList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetJingcaiGroupList', {params});
const getDongtaiYaowen = params =>
    axios.post(`${baseUrl}/api/ZhuJingBanXieHui/GetDongtaiYaowen?current=${params.current}&size=${params.size}`, params.lstType);
    
export {
    baseUrl,
    getBannerList,
    getYaowenList,
    getDangjianList,
    getProjectList,
    getProjectDetail,
    getFoodShop,
    getFoodShopDetail,
    getZhujingbanList,
    getPingpaiActivityList,
    getPlolicyDetail,
    getCityShowList,
    getJingcaiList,
    getJingcaiDetail,
    getProjectDown,
    getXiehuiModel,
    getXiehuiExport,
    getCompanyList,
    getCompanyDetail,
    getYaowen,
    getGongxiangZhujingban,
    getFocusNews,
    getZhujingbanWork,
    getGongxiang,
    getCompanynWork,
    getFoodArea,
    getFoodCookingStyle,
    getFoodList,
    getActivityList,
    getExpertList,
    addContact,
    login,
    addBaoming,
    getMedicalKnowledge,
    getKnowledgeDetail,
    getMedical,
    getProjectShow,
    addMatericalService,
    getZhengceList,
    getSearchKey,
    getXiehuiVIP,
    getJingcaiGroupList,
    getDongtaiYaowen,
};